import LangEnum from '../lang/LangEnum';
import { TranslateType } from '../modules/translation/translationContext.types';
import snackbarStore from '../stores/Snackbar.store';

interface HandleDownloadLinkParams {
  url: string;
  filename: string;
  translate: TranslateType;
}

export const handleDownloadMedia = ({ url, filename, translate }: HandleDownloadLinkParams) => {
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`download failed with status ${response.status}`);
      }

      return response.blob();
    })
    .then((blob) => {
      const objectUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = objectUrl;
      link.setAttribute('download', filename);

      document.body.appendChild(link);
      link.click();

      link.parentNode?.removeChild(link);
    })
    .catch(() => {
      snackbarStore.handleMessage({
        message: translate(
          LangEnum.GLOBAL_MEDIAS_DOWNLOAD_FAILED,
          undefined,
          'ocorreu um erro ao fazer o download',
        ),
        type: 'error',
      });
    });
};
